<template>
  <div class="wrapper">
    <Loader v-if="loading"/>
    <parallax
      class="section page-header header-filter"
      :style="{ backgroundImage: 'url(' + header_pictures.contact_header_picture.url + ')' }"
    ></parallax>
    <div class="main main-raised">
      <div class="section section-contacts">
        <div class="contact-container">
          <div class="md-layout contact-texts">
            <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto">
              <h2 class="title">{{contact_page.contact_page_header}}</h2>
              <vue-simple-markdown :source=contact_page.contact_details></vue-simple-markdown>
            </div>
          </div>
          <div class="md-layout contact-forms">
            <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto ">
              <div class="contact-form-container">
                <h2 class="title">{{contact_page.contact_form_header}}</h2>
                <h4>
                  {{contact_page.contact_form_text}}
                </h4>
                <div v-if="success" class="alert alert-success">
                  Great! Your message has been sent successfully. We will try to respond quickly.
                </div>
                <form 
                v-else
                v-on:submit.prevent="sendMessage"
                class="contact-form"
                >
                  <div v-if="errored" class="alert alert-danger">
                    Bummer, Something went wrong. Did you fill out all of the fields?
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Your Name</label>
                        <md-input v-model="form.name" type="text" required ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Your Email</label>
                        <md-input v-model="form.email" type="email" required ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label>Subject</label>
                        <md-input v-model="form.subject" type="text" required ></md-input>
                      </md-field>
                    </div>
                  </div>
                  <md-field maxlength="10" class="">
                    <label>Your Message</label>
                    <md-textarea v-model="form.message" required ></md-textarea>
                  </md-field>
                  <div class="" style="padding: 32px 0px;">
                    <div class="" style="float: right;">
                      <md-button class="md-primary" type="submit">{{ loading ? "Sending Message..." : "Submit" }}</md-button>
                    </div>
                  </div>
                </form>
              </div>
              
              
              <vue-simple-markdown :source=contact_page.more_contact_details></vue-simple-markdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    Loader
  },
  bodyClass: "profile-page",
  data() {
    return {
      contact_page: {},
      form: {
        name: '',
        email: '',
        subject:'',
        message: ''
      },
      loading: false,
      success: false,
      errored: false,
    };
  },
  props: {
    header_pictures: Object
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/contact-page", {}).then(
        (response) => {
            this.contact_page = response.data;
        },
        (error) => {
            // console.log(error);
        }
    );
  },
  computed: {
    
  },
  methods:{
    sendMessage(){
      axios.post("https://strapi-asiongs.herokuapp.com/messages", {
        name: this.form.name,
        email: this.form.email,
        subject: this.form.subject,
        message: this.form.message
      }).then((res) => {
        //Perform Success Action
        this.success = true;
        this.errored =false;
        // console.log("form success");
      }).catch((error) => {
        // error.response.status Check status code
        this.errored = true
        // console.log("form error");
      }).finally(() => {
        //Perform action in always
        this.loading = false
      });
    }
  },
  metaInfo() {
    return{
      title: 'Contact',
      meta: [
        { name: 'description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:title', content: "Asiong's Industrial Products"},
        { property: 'og:description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:site_name', content: 'Asiongs Industrial Products'},
        { property: 'og:type', content: 'website'},    
        { property: 'og:image', content: this.header_pictures.contact_header_picture.url}
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  } 
}
.contact-form-container{
  padding: 24px;
  border: 2px solid #eeeeee;
  margin: 32px 0px;
  border-radius: 8px;
}

.contact-form {
  margin-top: 30px;
}

.contact-text-area{
  margin-top: 15px;
}


.contact-container{
  display: grid;
  // grid-template-columns: repeat(auto-fit, minmax(400px , 1fr));
  
  // grid-template-columns:  minmax(280px , 1fr) minmax(280px , 2fr);
  grid-gap: 40px;
  // display: flex;
  // flex-flow: row wrap;
  max-width: 1440px;
  margin: auto;
  padding: 48px 24px;

  .contact-texts{
    margin-top: 56px;
  }

  .contact-forms{
    // flex-grow: 1;
    // min-width: 280px;
    // max-width: 800px;
  }
}

@media only screen and (min-width: 992px) {
    .contact-container{
      grid-template-columns:  1fr 2fr;
    }
}

@media only screen and (max-width: 991px) {
      .contact-container{
      grid-template-columns: repeat(auto-fit, minmax(280px , 1fr))
    }
  }

form{
  margin: 40px 0px;
}
</style>
